import React from 'react'
import {ProgressBar} from 'uikit'
import {config} from 'src/config'
import {useAppDispatch, useAppSelector} from 'store'
import {startProgressBar} from 'store/secretword/slice'
import {checkLetterThunk} from 'store/secretword/thunk'
import {isResetProgressbar, getCountOfError, isOpenWord} from 'store/secretword/selectors'
import {getTranslates} from 'store/translates/selectors'

export const ProgressBarGame = () => {
  const dispatch = useAppDispatch()
  const isRestart = useAppSelector(isResetProgressbar)
  const translates = useAppSelector(getTranslates)

  const countOfError = useAppSelector(getCountOfError)
  const isOpenWordFlag = useAppSelector(isOpenWord)
  const stop = (countOfError > config.countGuessAttempts) || isOpenWordFlag

  return (
    <ProgressBar
      userRestart={isRestart}
      message1={translates.FOR_CHOICE_YOU_HAVE}
      message2={translates.SEC}
      userStop={stop}
      userRestartProgress={() => {dispatch(startProgressBar())}}
      timeOver={() => {dispatch(checkLetterThunk(' '))}}
      maxTime={config.timeLimitToChooseLetter}
    />
  )
}
